<template>
  <div class="page-login">
    <div class="page-login__layout">
      <div class="page-login__brand">
        <div class="page-login__brand-header">
          <img
            class="page-login__brand-logo"
            src="/image/logo/login-logo.png"
          />
        </div>
        <div class="page-login__brand-main">
          <div class="page-login__brand-visual">
            <img
              class="page-login__brand-image"
              src="/image/login/brand-panel.png"
            />
          </div>
        </div>
      </div>

      <div class="page-login__panel">
        <div class="page-login__card">
          <div class="page-login__card-body">
            <div class="page-login__title">
              {{ $l('title_systemname') || '平台登录' }}
            </div>
            <div class="page-login__subtitle">
              {{ $l('login_subtitle_account') || '使用您的平台账号登录' }}
            </div>

            <el-form
              ref="loginForm"
              size="medium"
              :model="formLogin"
              :rules="loginRules"
              @keyup.native.enter="submit"
              class="page-login__form"
            >
              <el-form-item prop="account">
                <el-input
                  v-model="formLogin.account"
                  :placeholder="$l('login_tips_user') || '请输入登录账号'"
                  clearable
                />
              </el-form-item>

              <el-form-item prop="password">
                <el-input
                  v-model="formLogin.password"
                  :placeholder="$l('login_tips_pwd') || '请输入登录密码'"
                  type="password"
                  show-password
                  clearable
                />
              </el-form-item>

              <el-button
                type="primary"
                class="page-login__submit"
                @click="submit"
              >
                {{ $l('login_btn') || '登录' }}
              </el-button>
            </el-form>

            <div class="page-login__locale-row">
              <el-dropdown @command="changeLocale">
                <span class="page-login__locale">
                  <i class="fa fa-language" aria-hidden="true"></i>
                  {{ language.label }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="language in languages"
                    :key="language.value"
                    :command="language"
                  >
                    {{ language.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>

        <div class="page-login__footer">
          <p class="page-login__copyright">
            <a href="https://beian.miit.gov.cn" target="_blank">
              <span>
                {{
                  $l('login_company_name') || '地平线控股（苏州）股份有限公司'
                }}

                版权所有
              </span>
            </a>
            <a href="https://beian.miit.gov.cn" target="_blank">
              <span>
                {{ $l('login_company_icp') || '苏ICP备20023929号-2' }}
              </span>
            </a>
          </p>
        </div>
      </div>
    </div>

    <RestPasswordDialog
      :visible.sync="dialogFormVisible"
      :userCode="userCode"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import localeMixin from '@/locales/mixin.js'
import RestPasswordDialog from '@/components/resetpassword/dialog'
export default {
  components: { RestPasswordDialog },
  mixins: [localeMixin],
  data() {
    return {
      dialogFormVisible: false,
      userCode: '',
      formLogin: {
        account: '',
        password: '',
        appName: 'pla',
      },
      loginRules: {
        account: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/system', ['languages', 'language']),
  },
  created() {
    this.languagesLoad()
  },
  methods: {
    ...mapActions('admin/account', ['login']),
    ...mapActions('admin/system', ['languagesLoad']),
    submit() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return
        this._doLogin()
      })
    },
    _doLogin() {
      this.login(this.formLogin).then((res) => {
        const { status, body } = res
        if (status === 10001) {
          this.dialogFormVisible = true
          this.userCode = body
          return
        }
        this.$router.replace(this.$route.query.redirect || '/')
      })
    },
    changeLocale(val) {
      this.onChangeLocale(val)
      location.reload()
    },
  },
}
</script>

<style lang="scss">
.page-login {
  @extend %unable-select;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #2d3a4b;
  background: linear-gradient(70deg, #080c30, #182379);
  flex: 1;
  overflow: auto;
}

.page-login__layout {
  min-height: 100vh;
  display: flex;
  justify-content: space-between;
}

.page-login__brand {
  width: 50%;
  min-width: 0;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.page-login__brand-header {
  position: fixed;
  top: 40px;
  left: 40px;
}

.page-login__brand-logo {
  width: 200px;
}

.page-login__brand-main {
  position: relative;
  width: 100%;
  height: 100%;
}

.page-login__brand-visual {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.page-login__brand-image {
  width: 100%;
  object-fit: contain;
}

.page-login__panel {
  position: relative;
  z-index: 3;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin: 40px 40px 40px 0;
  align-self: stretch;
  width: 600px;
}

.page-login__card {
  flex-grow: 1;
  width: 600px;
  min-height: 670px;
  background: #fff;
  border-radius: 16px;
  box-shadow: none;
  padding: 28px 100px;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  overflow: hidden;
}

.page-login__form .el-form-item {
  margin-bottom: 18px !important;
}

.page-login__locale {
  display: inline-flex;
  align-items: center;
  color: #9da7c3;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
}

.page-login__locale .fa {
  margin-right: 6px;
}

.page-login__card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
}

.page-login__locale-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.page-login__title {
  color: #101010;
  font-size: 20px;
  line-height: 1.3;
  text-align: center;
  font-weight: 700;
}

.page-login__subtitle {
  margin-top: 14px;
  margin-bottom: 40px;
  color: #99a1b7;
  font-size: 13px;
  line-height: 1.7;
  text-align: center;
}

.page-login__submit.el-button {
  width: 100%;
  height: 40px;
  margin-top: 12px;
  border: 0 !important;
  border-radius: 4px;
  background-color: #4897f0 !important;
  font-size: 12px;
  font-weight: 600;
  padding: 0;
}

.page-login__submit.el-button:hover,
.page-login__submit.el-button:focus,
.page-login__submit.el-button:active {
  background-color: #3389ea !important;
  border-color: #3389ea !important;
  box-shadow: none !important;
}

.page-login__footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 50px;
  display: flex;
  justify-content: center;
}

.page-login__copyright {
  margin: 0;
  text-align: center;
  font-size: 12px;
  line-height: 1.8;
  color: #b6bdd0;
}

.page-login__copyright a {
  color: inherit;
  text-decoration: none;
}

.page-login__copyright a + a {
  margin-left: 10px;
}

@media screen and (max-width: 1024px) {
  .page-login__layout {
    justify-content: flex-end;
  }

  .page-login__brand {
    display: none;
  }
}

@media screen and (min-width: 1024px) {
  .page-login__brand-visual {
    position: absolute;
    inset: 0;
    width: 700px;
    margin: auto;
  }
}
</style>
